export const CONTACT_ROLES = [
    { key: 'registrant', label: '注册人' },
    { key: 'administrative', label: '管理联系人' },
    { key: 'technical', label: '技术联系人' },
    { key: 'billing', label: '财务联系人' }
];
